'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './profile.routes';

export class ProfileComponent {
  user = {};
  residencyRelations = {};

  datepickerOpened = {};

  /*@ngInject*/
  constructor(Auth, User, RequestedUserService, dialogs, $q, $stateParams, Config) {
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$q = $q;

    var profileConfig = Config.getModuleConfig(Config.Modules.Profile);
    var generalConfig = Config.getModuleConfig(Config.Modules.General);
    
    this.gender = profileConfig.getGenderTypes();
    this.phoneTypes = profileConfig.getPhoneTypes();
    this.socialMediaTypes = profileConfig.getSocialMediaTypes();
    this.mailTypes = profileConfig.getMailTypes();
    this.addressTypes = profileConfig.getAddressTypes();
    this.residencyRelationType = profileConfig.getResidencyRelationTypes();
    this.defaultResidencyRelationType = profileConfig.getDefaultResidencyRelationType();
    this.labelPrivate = profileConfig.getLabelPrivate();
    this.labelPublic = profileConfig.getLabelPublic();

    this.defaultPhoneType = profileConfig.getDefaultPhoneType();
    this.defaultSocialMediaType = profileConfig.getDefaultSocialMediaType();
    this.defaultMailType = profileConfig.getDefaultMailType();
    this.defaultAddressType = profileConfig.getDefaultAddressType();

    let residencyRelationsTexts = profileConfig.getResidencyRelationTexts();
    this.labelAppartmentConnections = residencyRelationsTexts.label || 'Apartment Connections';
    this.labelConnectionsActive = residencyRelationsTexts.textActive || 'I have connections';
    this.labelConnectionsInactive = residencyRelationsTexts.textInactive || 'I have no connections';

    this.buildings = generalConfig.getClientBuildings();
    this.unitNumbersByBuilding = generalConfig.getClientUnits();

    // If set, this profile is not my own - you look at an other user's profile
    this.userId = $stateParams.id;

    if (this.userId == 'unknown') {
      this.unknown = true;
      return;
    }

    if (this.userId) {

      // foreign profile
      this.isForeignProfile = true;

      let Service = User;

      if (this.type && this.type == 'invited')
        Service = RequestedUserService;

      Service.get({id: this.userId}, user => {
        this.user = user;

        this.isRealtorProfile = this.user.role.indexOf("realtor") != -1;
      });

      User.getResidencies({id: this.userId}, res => {
        this.residencyRelations = res.residencyRelations;
      });

    } else {

      // own profile
      Auth.getCurrentUser()
        .then(user => {
          this.user = user;
          this.isRealtorProfile = this.user.role.indexOf("realtor") != -1;
          return Auth.getResidencies(this.user._id);
        })
        .then(res => {
          this.residencyRelations = res.residencyRelations;
        })

    }

  }

  formatDialogElementInfo(elmInfo) {
    return "<br/><br/><b>"+elmInfo+"</b>";
  }

  addPhone() {
    this.user.profile.phone.push({
      type: this.defaultPhoneType,
      number: '',
      private: false
    });
  };

  removePhone(idx) {
    var phone = this.user.profile.phone[idx];
    var phoneString = phone.type + " " + phone.number;

    var dlg = this.dialogs.confirm(
      "Remove phone number?",
      "Do you really want to delete this phone number?" + this.formatDialogElementInfo(phoneString));
    dlg.result.then(() => {
      this.user.profile.phone.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addMail() {
    this.user.profile.email.push({
      type: this.defaultMailType,
      address: '',
      private: false
    });
  };

  removeMail(idx) {
    var mail = this.user.profile.email[idx];
    var mailString = mail.type + " " + mail.address;

    var dlg = this.dialogs.confirm(
      "Remove email?",
      "Do you really want to delete this email address?"+ this.formatDialogElementInfo(mailString));
    dlg.result.then(() => {
      this.user.profile.email.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addSocialMedia() {
    this.user.profile.socialMedia.push({
      type: this.defaultSocialMediaType,
      link: ''
    });
  };

  removeSocialMedia(idx) {
    var social = this.user.profile.socialMedia[idx];
    var socialString = social.type + " " + social.link;

    var dlg = this.dialogs.confirm(
      "Remove social link?",
      "Do you really want to delete this social media entry?" + this.formatDialogElementInfo(socialString));
    dlg.result.then(() => {
      this.user.profile.socialMedia.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addAddress() {
    this.user.profile.address.push({
      type: this.defaultAddressType
    });
  };

  removeAddress(idx) {
    var address = this.user.profile.address[idx];
    var addressString = (address.street || '') + "<br/>"
      + (address.street2 || '' ) + "<br/>"
      + (address.city || '') + " " + (address.state || '')  + " " + (address.zip || '') + "<br/>"
      + (address.country || '');

    var dlg = this.dialogs.confirm(
      "Remove address?",
      "Do you really want to delete this address?" + this.formatDialogElementInfo(addressString));
    dlg.result.then(() => {
      this.user.profile.address.splice(idx,1);
      this.saveChanges();
    }, () => {
      // Cancel
    });
  }

  addNewResidency() {
    if (!this.user.hasResidencyRelations)
      return;

    this.residencyRelations.push({
      unit: '',
      building: '',
      type: this.defaultResidencyRelationType
    });
  }

  removeResidency(idx) {
    var residency = this.residencyRelations[idx];
    var residencyString = residency.building + " / " + residency.unit + " / " + residency.type;

    // If the residency is empty and thus not yet set, one can remove the
    if (residency.building == '' && residency.unit == '') {
      this.residencyRelations.splice(idx,1);
      return;
    }

    var dlg = this.dialogs.confirm(
      "Remove apartment?",
      "Do you really want to delete this apartment connection entry?" + this.formatDialogElementInfo(residencyString));
    dlg.result.then(() => {
      this.residencyRelations.splice(idx,1);
      this.saveResidencies();
    }, () => {
      // Cancel
    });
  }

  getUnitsByBuilding(building) {
    // If there is no building selected, return an empty array
    if (typeof building == 'undefined')
      return [];

    return this.unitNumbersByBuilding[building];
  }

  saveChanges() {
    this.Auth.updateUser(this.user);
  }

  checkValidBuilding(data) {
    if (data.trim() === '')
      return "Please select a building";
  }

  checkValidUnitNumber(data) {
    // Build flat unit list from the units of each building
    var allowedUnits = [];
    this.buildings.forEach(building => {
      allowedUnits = allowedUnits.concat(this.unitNumbersByBuilding[building])
    });

    var unitInvalid = allowedUnits.indexOf(data) === -1;

    if (unitInvalid)
      return "Please select a valid unit number";
  }

  saveResidencies() {

    this.Auth.updateResidencies(this.user._id, this.residencyRelations, resRelationsIds => {
      // Set the new set of residency relation ids
      this.user.residencyRelations = resRelationsIds;
      
      // After updating the residencies, check if there is still an entry left,
      // if not: Set the Apartment Relations Flag to false
      if (this.residencyRelations.length == 0) {
        this.user.hasResidencyRelations = false;
        this.saveChanges();
      }
    });
  }

  checkValidPhone(phoneNumber) {
    var reUsPhoneNumber = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
    if (!reUsPhoneNumber.test(phoneNumber)) {
      return "Please enter a valid phone number in the following format: (xxx) xxx-xxxx";
    }
  }

  changePrimaryMail(mail, index) {
    /* Validate valid email */
    var reBasicEmailValidation = /\S+@\S+\.\S+/;
    if (!reBasicEmailValidation.test(mail)) {
      return "Please enter a valid email address";
    }

    /* Change primary email */

    var primary = (index === 0);

    if (!primary)
      return;

    var defer = this.$q.defer();

    this.user.email = mail;

    this.Auth.changeEmail(this.user._id, mail).then(() =>{
      defer.resolve();
    }).catch(res => {
      defer.resolve(res.data.errors.email.message);
    });

    return defer.promise;
  }
}

export default angular.module('conduuApp.profile', [uiRouter])
  .config(routes)
  .component('profile', {
    template: require('./profile.html'),
    controller: ProfileComponent,
    controllerAs: 'profileCtrl',
    bindings: {
      type: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/profile/profile.component.js